import addToCartBackOrderModel from './addToCartBackOrderModel';

export default class AddToCartBackOrder {
	constructor(modalInstance = {}) {
		this.modalInstance = modalInstance;
		this.addToCartModalId = 'addToCartBackOrder';
		this.cartEntries = [];

		if (this.modalInstance.modal) {
			this.modalHtml = this.modalInstance.modal.element;
			this.addToCartBackOrderButton = this.modalHtml.querySelector(
				'#addToCartBackOrderCheckout',
			);

			if (this.addToCartBackOrderButton) {
				this.modalTrigger();
			}
		}
	}

	modalTrigger() {
		this.addToCartBackOrderButton.addEventListener('click', e => {
			e.preventDefault();

			this.getBackOrderData(e);
			this.getReplacementProductData();
			this.addToBasketCheck();
		});
	}

	addToBasketCheck() {
		if (this.cartEntries.length) {
			this.populateAddToCartModal();
		} else {
			this.modalInstance.modal.hide();
		}
	}

	getBackOrderData(e) {
		const backOrderQty = this.modalHtml.querySelector(
			'input[name=stock-option]:checked',
		).value;

		if (parseInt(backOrderQty, 10)) {
			const sku = e.currentTarget.getAttribute('data-product-sku');
			const quantity = backOrderQty;

			this.addCartEntry(sku, quantity);
		}
	}

	getReplacementProductData() {
		const replacementProduct = this.modalHtml.querySelector(
			'#replacementProduct',
		);

		if (replacementProduct === null) {
			return;
		}

		const quantity = replacementProduct.querySelector('input[name=qty]').value;

		if (parseInt(quantity, 10)) {
			const sku = replacementProduct.getAttribute('data-product-sku');

			this.addCartEntry(sku, quantity);
		}
	}

	addCartEntry(sku, quantity) {
		const productData = {
			sku,
			quantity,
		};

		this.cartEntries.push(productData);
	}

	populateAddToCartModal() {
		return addToCartBackOrderModel(this.cartEntries).then(result => {
			const { data } = result;

			this.modalInstance.insertResponse(data, this.addToCartModalId);
		});
	}
}
